import React from 'react';
import './WhyChooseUs.css';
import { FaCheckCircle, FaUsersCog, FaDollarSign, FaChartLine, FaTools, FaGlobe } from 'react-icons/fa';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: <FaCheckCircle />,
      title: 'Verified Leads',
      description: 'We deliver pre-vetted, high-quality leads that are ready to convert, ensuring your sales team focuses on the right prospects.'
    },
    {
      icon: <FaUsersCog />,
      title: 'Dedicated Sourcing Experts',
      description: 'Our team of experienced professionals brings deep industry knowledge and a commitment to delivering consistent, precision-driven results.'
    },
    {
      icon: <FaDollarSign />,
      title: 'Cost-Effective Solutions',
      description: 'Save time and money with our affordable, scalable services designed to maximize ROI without compromising on quality.'
    },
    {
      icon: <FaChartLine />,
      title: 'Faster Recruitment Cycles',
      description: 'Reduce time-to-hire significantly with our streamlined sourcing processes and proactive candidate engagement strategies.'
    },
    {
      icon: <FaTools />,
      title: 'Advanced Research Tools',
      description: 'Leverage cutting-edge tools, methodologies, and data-driven insights to stay ahead in competitive markets.'
    },
    {
      icon: <FaGlobe />,
      title: 'Global Reach',
      description: 'With experience across the UK, USA, Canada, Europe, and Australia, we understand diverse markets and deliver localized solutions.'
    }
  ];

  return (
    <section className="why-choose-us section" id="why-choose-us">
      <div className="container">
        <h2 className="section-title">Why Choose LTSS?</h2>
        <p className="section-subtitle">
          Unmatched expertise and results-driven strategies designed for your success.
        </p>
        
        <div className="reasons-grid">
          {reasons.map((reason, index) => (
            <div className="reason-card" key={index}>
              <div className="reason-icon">{reason.icon}</div>
              <h3 className="reason-title">{reason.title}</h3>
              <p className="reason-description">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;